import { render, staticRenderFns } from "./OnboardingCompanyPage.vue?vue&type=template&id=03e22dd0&scoped=true&"
import script from "./OnboardingCompanyPage.vue?vue&type=script&lang=js&"
export * from "./OnboardingCompanyPage.vue?vue&type=script&lang=js&"
import style0 from "./OnboardingCompanyPage.vue?vue&type=style&index=0&id=03e22dd0&prod&lang=scss&"
import style1 from "./OnboardingCompanyPage.vue?vue&type=style&index=1&id=03e22dd0&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "03e22dd0",
  null
  
)

export default component.exports